export function getCanvasMaxSize(zoneId) {
  const section = document.querySelector(zoneId);
  const w = section.clientWidth;

  const body = document.body;
  const html = document.documentElement;
  const h = Math.min(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  );
  return Math.min(w, h);
}
